import styled from 'styled-components';
import { SVGIcon, Text, mixins, colors, media } from '@custom-components';

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  .spacer {
    flex-grow: 1;
  }
`;

// MOBILE SPECIFIC
// ${({ theme }) => `background-color: ${theme.lighterText}`};
export const MobileStepsContainer = styled.div`
  background-color: ${colors.colorWhite};
  width: 100%;
  padding: ${mixins.pxToRem(10)};
`;

// Progress Bar
export const StyledProgressItem = styled.span`
  display: inline-block;
  vertical-align: top;
  width: ${(props) => props.width}%;
  text-align: center;
  padding: ${mixins.pxToRem(7)} 0;
`;

export const StyledSVGIcon = styled(SVGIcon)`
  margin-right: 0.5rem;
  display: inline-block;
`;

export const StyledArrowSVGIcon = styled(SVGIcon)`
  transform: translateY(-50%) rotate(180deg);
  position: absolute;
  top: 50%;
  left: 0;
`;

export const BackSVGIcon = styled(SVGIcon)`
  transform: rotate(180deg);
`;

export const StyledPara = styled(Text.CopyParagraph)`
  position: relative;
  margin: ${mixins.pxToRem(15)} 0;
  display: inline-block;
  cursor: default;

  ${media.greaterThan('lg')`
    margin: 0;
  `};
`;

export const StyledBar = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${colors.colorGrey04};
  position: relative;

  &:before {
    content: ' ';
    position: absolute;
    top: -1px;
    left: 0;
    height: 4px;
    background-color: ${colors.colorBlue};
    width: ${(props) => (props.barWidth > 100 ? 100 : props.barWidth)}%;
  }
`;

export const StyledBackButton = styled.button`
  cursor: pointer;
  outline: none;
`;

export const StyledMobileContainer = styled.div`
  position: relative;
  text-align: center;
`;

export const StyledHeadingFourth = styled(Text.HeadingFourth)`
  margin: 1rem 0 1.6rem;
`;

export const StyledSubHeadingFifth = styled(Text.HeadingFifth)`
  margin: 1rem 0;
  color: ${colors.colorGrey03};
`;

export const ProgressBarContainer = styled.div`
  background-color: ${colors.colorWhite};
  padding: ${mixins.pxToRem(20)} 0 ${mixins.pxToRem(16)};
`;

export const StyledButton = styled.button`
  outline: none;
  cursor: pointer;
`;

export const StyledInfoContainer = styled.div`
  width: 100%;
  border: 1px solid;
  ${({ theme, editing }) => (editing ? `border-color: ${theme.highlightTheme}` : `border-color: ${theme.lightText}`)};
`;

export const StyledContainer = styled.div`
  width: 100%;
  background-color: ${colors.colorWhite};
  ${({ noPadding }) => ` padding: ${noPadding ? `0` : mixins.pxToRem(20)}`};
  display: flex;
  flex-direction: column;
`;
